// const SAN_FRANCISCO = { lat: 37.773972, lng: -122.431297 };
const USA_GEO_CENTER = { lat: 39.8283459, lng: -98.5794797 };
const MAP_CONFIG = {
  ZOOM: 3,
  CENTER: USA_GEO_CENTER,
};

export default MAP_CONFIG;
